import { theme } from '@bottlebooks/gatsby-design-system';
// TODO move the event directories to that spacing scale too eventually.
const space = theme.space; // [0, 5, 10, 15, 20, 25, 30, 40, 50, 70];
/**
 * The spacing for fluid containers.
 */
space.gutter = 8;
/**
 * Negative spacing for the container Row.
 */
space['-gutter'] = -space.gutter;
/**
 * The space between grid columns.
 */
space.columnGap = 16;
/**
 * Negative spacing for the container Row.
 */
space['-columnGap'] = -space.columnGap;
/**
 * The height of the navbar.
 * Used for positioning sticky items directly beneath the black navbar, for example the main menu.
 */
space.navbar = 50;
/**
 * The position of the menu bar (NavBar + MenuBar height).
 * Used for positioning sticky items directly beneath the black navbar, for example tables.
 */
space.menubar = space.navbar + 70;
space.smallMenubar = space.navbar + 50;
export default space;
//# sourceMappingURL=space.js.map